<template>
  <div>
    <mobile v-if="isMobile"/>
    <pc v-else/>
  </div>
</template>

<script>
import { defineComponent, ref, onMounted, onUnmounted } from 'vue';
import Pc from './pc'
import Mobile from './mobile'

export default defineComponent({
  name: 'home-index',
  components: {
    Pc, Mobile
  },
  setup() {
    const isMobile = ref(false);

    // 检测方法：结合 UA 和窗口宽度
    const checkDevice = () => {
      const userAgent = window.navigator.userAgent;
      const isMobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
      const isMobileWidth = window.innerWidth < 768; // 768px 作为移动端断点

      // UA 是移动设备 或 窗口宽度小于 768px 都视为移动端
      isMobile.value = isMobileUA || isMobileWidth;
    };

    // 防抖处理，避免 resize 频繁触发
    let resizeTimer = null;
    const handleResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        checkDevice();
      }, 200);
    };

    onMounted(() => {
      checkDevice(); // 初始检测
      window.addEventListener('resize', handleResize);
    });

    onUnmounted(() => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(resizeTimer);
    });

    return {
      isMobile,
    };
  },
});
</script>

<style scoped>
</style>
